import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__en-US.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const QAPageJsonld = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  breadcrumb: 'Lemonade.com > Lemonade FAQ',
  name: 'Lemonade FAQ',
  image:
    'https://www.lemonade.com/assets/lemonade-share-image-ad9d7846f31685bfb4af89f018e4dd5d460f4e73768a8fd500bfc1f069ff853a.png',
  description:
    'FAQs on Lemonade Insurance, a property and casualty insurance company offering policies to renters and homeowners.',
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    title: 'FAQ for Renters, Homeowners, Car, Pet, and Life Insurance | Lemonade',
    metaTitle: 'FAQ for Renters, Homeowners, Car, Pet, and Life Insurance | Lemonade',
    description: 'Get all your insurance questions answered in plain English - by Lemonade Insurance.',
    jsonld: [QAPageJsonld],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
